import { memo } from 'react';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useMenu from 'hooks/useMenu';

function AccountButton(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleChangeMenu, changeMenu } = useMenu();
  const handleClick = () => {
    if (location.pathname === '/admin/account') {
      return;
    }
    handleChangeMenu([]);
    navigate('/admin/account', {
      state: { from: location.pathname || '/admin/project/overview', id: changeMenu?.[0] || 'project' },
    });
  };
  return (
    <Button variant="contained" color="primary" onClick={handleClick}>
      계정 관리
    </Button>
  );
}

export default memo(AccountButton);
